import { AddGeoLocationComponent} from './add-geolocation/add-geolocation.component';
import { EditGeoLocationComponent} from './edit-geolocation/edit-geolocation.component';
import { ViewGeoLocationComponent} from './view-geolocation/view-geolocation.component'

export const GeoLocationModuleDeclaration = [
    AddGeoLocationComponent,
    EditGeoLocationComponent,
    ViewGeoLocationComponent
];